var render = function render(){var _vm=this,_c=_vm._self._c;return _c('option-selection',{staticClass:"mt-4",attrs:{"allow-custom-choice":_vm.question.settings.hasOtherOption,"options":_vm.question.options},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}})
}
var staticRenderFns = []

export { render, staticRenderFns }